import dayjs from "dayjs";

export const clienteDaFilial = (filiais, branchId) =>
  filiais.find((filial) => filial.id === branchId)?.client_id ?? null;

export const filiaisDoCliente = (filiais, clientId) =>
  filiais
    .filter((filial) => filial.client_id === clientId)
    .map((filial) => filial.id);

export const filiaisDoFiltro = (filiais, selecionadas, filialAtiva) => {
  if (selecionadas.length) return selecionadas;
  return filiaisDoCliente(filiais, clienteDaFilial(filiais, filialAtiva));
};

export const arvoreDeFiliais = (filiais, clienteLiberado = null) => {
  const porCliente = {};
  filiais.forEach((filial) => {
    const clientId = filial.client_id ?? "unknown";
    const bloqueado =
      clienteLiberado !== null && filial.client_id !== clienteLiberado;
    if (!porCliente[clientId]) {
      porCliente[clientId] = {
        title: filial.client_name || "Cliente",
        value: `__client_${clientId}`,
        selectable: false,
        disabled: bloqueado,
        children: [],
      };
    }
    porCliente[clientId].children.push({
      title: filial.name,
      value: filial.id,
      disabled: bloqueado,
    });
  });
  return Object.values(porCliente);
};

export const periodoSemiaberto = ([inicio, fim]) => ({
  start: inicio ? dayjs(inicio).format("YYYY-MM-DD") : undefined,
  end: fim ? dayjs(fim).add(1, "day").format("YYYY-MM-DD") : undefined,
});
